import React from "react";
import { Button, Col, Row } from "reactstrap";
import { useSelector } from "react-redux";

import host from "assets/images/sbs/sbs_tot/host.png";
import dummyAvatar from "assets/images/sbs/dummyAvatar.png";
import logoTot from "assets/images/sbs/sbs_tot/logo_TOT.png";
import playIcon from "assets/images/sbs/sbs_tot/play-icon.png";
import guesserBox from "assets/images/sbs/sbs_tot/guesser-box.png";
import { removeUser } from "components/shared/utils";

const PreGuess = ({ users, status, onTimesUpTot, totRightWords }) => {
  const roomObj = useSelector((state) => state.gameReducer?.roomObj);
  const guesserPlayerId = useSelector(
    (state) => state.gameReducer?.roomObj?.game_state?.active_player
  );
  const guesserData = users.filter(
    (user) => guesserPlayerId === user.player_id
  );

  const delPlayer = (data) => removeUser(roomObj, data);

  return (
    <div className="preguess-screen">
      <div className="total-score">
        <p className="txt">total score</p>
        <p className="score">{totRightWords?.length}</p>
      </div>
      <Row>
        <Col lg={12} xl={12} className="my-3">
          <img src={logoTot} alt="" />
        </Col>
      </Row>
      <Row style={{ height: "92%" }}>
        <Col lg={3} xl={3} className="offset-1 preguess-col">
          {status === "JoiningTOT" ? (
            <div className="joining-tot">
              <p className="text">
                Get ready to play a round of Tip of the Tongue!
              </p>
              <p className="text">
                Once at least 2 people have joined, click below to START
              </p>
              <Button
                onClick={() => onTimesUpTot({ gameCode: "TOT" })}
                className="start-btn"
              >
                start <img src={playIcon} className="playIcon" alt="" />
              </Button>{" "}
            </div>
          ) : (
            <div className="tot-guesser-wrapper">
              <div className="tot-guesser-text">
                <p className="text">
                  Help the Guesser score as many points as possible!
                </p>
                <p className="text">
                  The Guesser is choosing a category on their phone.
                </p>
                <div className="time-left">
                  <p className="txt">Time Left</p>
                  <p className="time">60</p>
                </div>
                <div className="circle">
                  <div className="circle-inner1">
                    <div className="circle-inner2">
                      <img
                        src={
                          guesserData[0]?.profile_image !== "profileImage"
                            ? guesserData[0]?.profile_image
                            : dummyAvatar
                        }
                        className="img"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="lobby-guesser-box">
                <img src={guesserBox} alt="" />
                <p className="guesser">
                  {guesserData[0]?.display_name.length > 15
                    ? guesserData[0]?.display_name.slice(0, 15) + "..."
                    : guesserData[0]?.display_name}
                </p>
              </div>
            </div>
          )}
        </Col>
        <Col lg={4} xl={4} className="offset-1">
          <div className="sbs-tot-lobby-players">
            <div className="sbs-tot-lobby-players-list">
              {users &&
                users?.length > 0 &&
                users?.map((user) => (
                  <div
                    key={user.user_id}
                    className="sbs-tot-lobby-players-flex"
                  >
                    <div className="players-info">
                      <img src={user.profile_image} className="mr-2" alt="" />
                      <p className="name">
                        {user.display_name.length > 15
                          ? user.display_name.slice(0, 15) + "..."
                          : user.display_name}
                      </p>
                    </div>
                    <div className="d-flex align-items-center">
                      <h6 className="score">{user?.score ? user?.score : 0}</h6>
                      <h6 onClick={() => delPlayer(user)} className="remove">
                        X
                      </h6>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Col>
        <Col lg={3} xl={3} className="preguess-col-host p-0">
          <div className="host">
            <img src={host} className="hostImg" alt="" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PreGuess;
